export default __webpack_public_path__ + "static/media/kartu-ilubin.0f1b5527.png";